import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { DataService } from 'src/app/services/data.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-catalogs-popup',
  templateUrl: './catalogs-popup.component.html',
  styleUrls: ['./catalogs-popup.component.scss'],
})
export class CatalogsPopupComponent implements OnInit {
  catlogData: any[] = [];
  informationServices: any[] = [];
  displayedColumns: string[] = ['name', 'price'];
  load: boolean = false;
  loadMessage: string;
  dataSource = new MatTableDataSource<any>();
  darkTheme: boolean;
  tooltipImagePath: string;
  activeUser: any;
  error: boolean;
  sensorId:string;
  savedSelections:[];
  checkedItems: any[] = [];


  
  constructor(
    private catlogRef: MatDialogRef<CatalogsPopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private apiService: ApiService,
    private dataService: DataService,
    private authService: AuthService,
  ) {
    let isOpenWater = this.data.isOpenWater ? true : false;
    this.apiService.getInformationServices(this.data.sensorTypes,this.data.taskId,isOpenWater).subscribe((result: any) => {
      if (result.msg === 'Success') {
        this.load = false;
        this.informationServices = result.informationServices;
        const isDisabled =
        this.data.status != 'approved' 
        this.informationServices = result.informationServices.map(item => ({
        ...item,
        sensorId: this.data.sensorId,
        enabled : !isDisabled
      }));
      const feedIds = (this.data.feedData || [])
        .filter(f => f.sensorId === this.data.sensorId) 
        .map(f => f._id);

        this.informationServices = this.informationServices.map(item => ({
        ...item,
        isChecked: item.isChecked || (feedIds.includes(item._id) && item.sensorId === this.data.sensorId)
      }));
        const storageKey = `catalogData_task_${this.data.taskId}_sensor_${this.data.sensorId}`;
        const savedCatalog = localStorage.getItem(storageKey);

        if (savedCatalog) {
          const stored = JSON.parse(savedCatalog);
          // Merge stored isChecked states into API result
          this.informationServices = this.informationServices.map(item => {
            const match = stored.find(s => s._id === item._id);
            return match ? { ...item, isChecked: match.isChecked } : item;
          });
        }
        this.dataSource = new MatTableDataSource<any>(this.informationServices);
      } else {
        this.loadMessage = 'Sorry, no information feeds found';
      }
    });

    this.dataService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;
      this.tooltipImagePath = this.darkTheme ? '../../../assets/images/union-dark.svg' : '../../../assets/images/union.svg';
    });
  }

  ngOnInit(): void {
    this.load = true;
    this.loadMessage = 'Getting information feeds...';
    this.authService.user.subscribe((user) => (this.activeUser = user));
  }

  onClick(click): void {
    if (click === 'yes') {
      if (this.catlogData.length > 0) {
        if (this.data?.isOpenWater && (this.catlogData[0]?.taskingArea != 'water' && this.catlogData[0]?.taskingArea != 'both')) {
        this.error = true
        } else if (!this.data?.isOpenWater &&(this.catlogData[0]?.taskingArea != 'land' && this.catlogData[0]?.taskingArea != 'both')) {
        this.error = true
      } else {
        const storageKey = `catalogData_task_${this.data.taskId}_sensor_${this.data.sensorId}`;
        localStorage.setItem(storageKey, JSON.stringify(this.catlogData));
        this.catlogRef.close(this.catlogData);
      }
      } else {
        this.catlogRef.close(this.catlogData);
      }
    } else if (click === 'no') {
      this.catlogRef.close(click);
    }
  }
  onItemChange(item: any): void {
    this.error = false;
    item.isChecked = !item.isChecked;
    if (item.isChecked) {
      if (this.data?.isOpenWater && (item.taskingArea != 'water' && item.taskingArea != 'both')) {
       this.error = true
      } else if (!this.data?.isOpenWater && (item.taskingArea != 'land' && item.taskingArea != 'both')) {
        this.error = true
      }
      if (!this.checkedItems.find(i => i._id === item._id)) {
      this.checkedItems.push(item);
      }
    }
    this.informationServices = this.informationServices.map(i =>
      i._id === item._id ? { ...i, isChecked: item.isChecked } : i
    );
    this.catlogData = [...this.informationServices];
  }
  getIsToolTip(row: { description: string; f1Score?: number }): string {
    let tooltip = row.description;
    return tooltip;
  }
}
